import { render } from "./App.vue?vue&type=template&id=ac8f5782"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ac8f5782&lang=less"

import exportComponent from "E:\\ekt.pro.git\\new-ekt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__